module.exports = __webpack_public_path__ + "/static/assets/52886015226b693acd9c15e33d924075.svg";